import { ODataSelect } from "@iconics/core";

export class User extends ODataSelect
{
    public Id = '';
    public DisplayName?: string;
    public IdentityProviderId = 0;
    public UserType = '';
    public UserName = '';
    public FirstName?: string;
    public LastName?: string;
    public PreferredName?: string;
    public Initials?: string;
    public Email = '';

    public toSelect(): string
    {
        return ''; // $select doesn't support DisplayName
    }
}
